module.exports = __webpack_public_path__ + "static/media/icon_small_transparent.80dcd5f6.png";